<template>
  <div class="sakit">
    <BackSection :menu="name" />
    <div class="container-fluid">
      <FormWish />
    </div>
  </div>
</template>

<script>
import FormWish from "@/components/FormWish.vue";
import BackSection from "@/components/BackSection.vue";
export default {
  setup() {
    return {
      name: "Form Wish",
    };
  },
  components: {
    BackSection,
    FormWish,
  },
};
</script>
